import {useEffect} from "react";
import T from "platformed-components/i18n/T";
import {toaster} from "../components/ui/toaster";
import {hasBrokenErrorSubclassing} from "../utils/brokenEnvironment";
import {domainType} from "../utils/environment";

// Module-scoped so StrictMode's double-mounted effect and later re-renders show
// the warning at most once per page load.
let shown = false;

export default function BrokenEnvironmentToast() {
  useEffect(() => {
    // Not on the Trust Center, a public customer-facing surface where blaming a
    // visitor's own extension isn't ours to say. Reports are still dropped and
    // counted upstream there regardless.
    if (shown || domainType === "TrustCenter" || !hasBrokenErrorSubclassing()) return;
    shown = true;
    toaster.create({
      id: "broken-js-environment",
      type: "warning",
      closable: true,
      duration: Number.POSITIVE_INFINITY,
      title: <T keyName="c.Some_features_may_not_work" />,
      description: (
        <T
          keyName="app.broken_environment.toast_description"
          defaultValue="A browser extension appears to be interfering with this page, so some features may not work correctly."
        />
      ),
    });
  }, []);
  return null;
}
